import React from 'react';
import s from './s.module.less';
import Icon from './icon.png';
import { Button } from 'antd';
import { disconnetFromGoogle } from 'api/provider';
import useGoogleAuthStatus from 'hooks/useGoogleAuthStatus';
import GoogleAuthCalendarSetting from 'pages/dashboard/CalendarManagePage/components/GoogleAuthCalendarSetting';
import useGoogleCategory from 'hooks/useGoogleCategory';

interface DisconnectBannerProps {
    onUpdate: () => void;
}

const DisconnectBanner = ({ onUpdate }: DisconnectBannerProps) => {
    const [authStatus] = useGoogleAuthStatus();
    const [showGoogleAuthCalendarSetting, setShowGoogleAuthCalendarSetting] = React.useState(false);
    const [googleCategory, googleCategoryLoading, fetchGoogleCategory] = useGoogleCategory();
    const showManage = googleCategory && googleCategory.length > 0;
    const onDisconnect = async () => {
        try {
            await disconnetFromGoogle();
            onUpdate();
        } catch (error) {
            console.error(error);
        }
    };

    const onManage = () => {
        setShowGoogleAuthCalendarSetting(true);
    };

    return (
        <div className={s.wrap}>
            <div className={s.left}>
                <img src={Icon} width={50} height={50} />
                <div className={s.info}>
                    <div className={s.title}>
                        Google Calendar
                    </div>
                    <div className={s.des}>
                        {authStatus?.email}
                    </div>
                </div>
            </div>
            <div className={s.right}>
                <Button onClick={onDisconnect}>Disconnect</Button>
                {
                    showManage &&
                    <Button style={{ marginLeft: '8px' }} type="primary" onClick={onManage}>Manage</Button>
                }
            </div>
            <GoogleAuthCalendarSetting show={showGoogleAuthCalendarSetting} onClose={() => setShowGoogleAuthCalendarSetting(false)} />
        </div>
    );
};

export default DisconnectBanner;
